import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { PropTypes as MicromagPropTypes } from '@micromag/core';
import { Link } from '@micromag/core/components';
import { useUrlGenerator } from '@micromag/core/contexts';

import SettingsButton from '../buttons/Settings';
import ScreenItem from './Screen';
import ThemeMenu from '../menus/Theme';
// import Authors from '../partials/Authors';
import { isTouchDevice } from '../../lib/utils';

import styles from '../../../styles/items/theme.module.scss';

const propTypes = {
    item: MicromagPropTypes.story.isRequired,
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const ThemeItem = ({ item, className }) => {
    const url = useUrlGenerator();
    const { components: screens = [] } = item;
    const screensCount = screens.length;
    const screen = screensCount > 0 ? screens[0] : null;

    const touchDevice = isTouchDevice();

    return (
        <div
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                    [styles.isMouseDevice]: !touchDevice,
                },
            ])}
        >
            <div className={classNames(['rounded', 'bg-secondary', styles.screen])}>
                <Link
                    to={url('themes.show', {
                        theme: item.id,
                    })}
                    className={classNames([styles.link])}
                >
                    <h4 className={classNames(['card-title', 'text-white', 'p-2', styles.title])}>
                        {item.title}
                    </h4>
                </Link>
                {screen !== null ? <ScreenItem item={screen} className={styles.preview} /> : null}
            </div>
            <div className={classNames([styles.top, 'p-2'])}>
                <SettingsButton
                    theme="light"
                    iconOnly
                    dropdown={
                        <ThemeMenu
                            className={styles.menu}
                            theme={item}
                            asDropdown
                            withoutDropdown
                            withDuplicate
                            withDelete
                        />
                    }
                />
            </div>
        </div>
    );
};

ThemeItem.defaultProps = defaultProps;
ThemeItem.propTypes = propTypes;

export default ThemeItem;
